import { useTranslations } from "next-intl";
import dynamic from "next/dynamic";
import Image from "next/image";
import { FC, useCallback, useState } from "react";
import { TransformComponent, TransformWrapper, useControls } from "react-zoom-pan-pinch";
import "swiper/css";
import "swiper/css/navigation";

import Icon from "@/components/ui/Icon/Icon";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "../ui/Button/Button";

const Modal = dynamic(() => import("@/components/ui/Modal/Modal"), { ssr: false });
const ModalContent = dynamic(() => import("@/components/ui/Modal/ModalContent"), { ssr: false });

export interface MagnifyModalProps {
  closeModal: () => void;
  floorPlanImage: string;
}

const Controls = () => {
  const { zoomIn, zoomOut, resetTransform } = useControls();

  return (
    <div className="tools absolute right-[30px] bottom-[30px] flex flex-col z-10 gap-xs">
      <button
        className="w-[40px] h-[40px] border rounded-full flex items-center justify-center hover:bg-black-0 hover:text-white"
        onClick={() => zoomIn()}
      >
        +
      </button>
      <button
        className="w-[40px] h-[40px] border rounded-full flex items-center justify-center hover:bg-black-0 hover:text-white"
        onClick={() => zoomOut()}
      >
        -
      </button>
      <button
        className="w-[40px] h-[40px] border rounded-full flex items-center justify-center hover:bg-black-0 hover:text-white"
        onClick={() => resetTransform()}
      >
        x
      </button>
    </div>
  );
};

const MagnifyModal: FC<MagnifyModalProps> = ({ floorPlanImage, closeModal }) => {
  const t = useTranslations();
  return (
    <>
      <Modal open onClose={closeModal}>
        <ModalContent className="w-full h-full !rounded-none  py-l">
          <div className="flex justify-between pb-l">
            <h2 className="font-medium uppercase font-primary text-m ">{t("project.label.zoomModal")}</h2>
            <Button className="modal__close" size={ButtonSize.MEDIUM} variant={ButtonVariant.TERTIARY} theme={ButtonTheme.BLACK} onClick={closeModal}>
              <span className="pointer-events-none">
                <Icon name="close" size="24" title="close" className="stroke-black" />
                <span className="sr-only">{t("button.label.close")}</span>
              </span>
            </Button>
          </div>
          <TransformWrapper initialScale={1} centerOnInit={true} disablePadding={true} smooth={true}>
            {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
              <>
                <Controls />
                <TransformComponent
                  wrapperStyle={{ margin: "auto", width: "100%", height: "90vh" }}
                  contentStyle={{ margin: "auto", width: "100%", height: "100%", cursor: "pointer" }}
                >
                  <Image src={floorPlanImage} alt="" className="max-h-5xl md:max-h-[500px] w-full object-contain m-auto" fill />
                </TransformComponent>
              </>
            )}
          </TransformWrapper>
        </ModalContent>
      </Modal>
    </>
  );
};

export default MagnifyModal;
